import Cookies from "js-cookie";
import axiosClient from "../api/axiosClient";
import moment from "moment";

export const getAccessToken = () => Cookies.get("cms_access_token");
export const isAuthenticated = () => !!getAccessToken();

export const requiredFieldValidator = (fields, formData, type) => {
  let errors = {};
  let regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  let emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
    if (type) {
    errors[type] = [];
    formData?.map((data, index) => {
      if (
        !(
          data["bio_raw"]
            ?.replace(/<\/?[^>]+(>|$)/g, "")
            .replace(/&nbsp;/g, " ").length -
          1 >=
          100 &&
          data["bio_raw"]
            ?.replace(/<\/?[^>]+(>|$)/g, "")
            .replace(/&nbsp;/g, " ").length -
          1 <=
          1500
        )
      ) {
        if (
          data["bio_raw"]
            ?.replace(/<\/?[^>]+(>|$)/g, "")
            .replace(/&nbsp;/g, " ") &&
          data["bio_raw"]
            ?.replace(/<\/?[^>]+(>|$)/g, "")
            .replace(/&nbsp;/g, " ")
            .trim() !== "" &&
          data["bio_raw"]
            ?.replace(/<\/?[^>]+(>|$)/g, "")
            .replace(/&nbsp;/g, " ") !== null
        ) {
          errors[type][index] = {
            id: index,
            ["bio_raw"]: `Please enter minimum 100 and max 1500 characters1`,
          };
        }
      }
      if (
        data?.["link"] &&
        !/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
          data["link"]
        )
      ) {
        errors[type][index] = { id: index, ["link"]: `Enter valid url` };
      }
      fields.filter((x) => {
        // Condition for virtual_event and meet_link
        if (!data?.virtual_event && x.name === "meet_link") return false;
        
        // Condition for is_location_required and related fields
        if (!data?.is_location_required && 
            (x.name === "event_location" || x.name === "event_address" || x.name === "address_link")) 
          return false;
        
        // Condition for event_video_link or upload_video_link and link_text
        if ((!data?.event_video_link && !data?.upload_video_link) && x.name === "link_text") return false;
        
        // Condition for event_pdf_link and pdf_text
        if (!data?.event_pdf_link && x.name === "pdf_text") return false;
        
        // Add more conditions as needed
        if (!data?.multiday_event && x.name === "event_end_date") return false;
  
        // If none of the above conditions are met, return true to keep the field
        return true;
      }).map((field) => {
        if(field.name === "program_id" || field.name === 'event_time_zone'){
          if(index === 0 &&  !data[field.name]?.length){
            errors[type][index] = {
              ...errors[type][index],
              id:index,
              [field.name]: `${field.fieldName} is required`,
            }
          }
        }
        else if ((!data[field.name] && (field.name !== "bio_raw" || field.name !== "overview" ||  field.name !== "event_description"))) {
          if (errors[type]) {
            errors[type][index] = {
              ...errors[type][index],
              id: index,
              [field.name]: `${field.fieldName} is required`,
            };
          } else {
            errors[type] = [
              { id: index, [field.name]: `${field.fieldName} is required` },
            ];
          }
        } else {
          if(field.name === "event_description") {
            if (
              !(
                data?.[field.name]
                  ?.replace(/<\/?[^>]+(>|$)/g, "")
                  .replace(/&nbsp;/g, " ").length -
                1 >=
                1
              )
            ) {
              if (errors[type]) {
                errors[type][index] = {
                  ...errors[type][index],
                  id: index,
                  [field.name]: `${field.fieldName} is required`,
                };
              }
            }
          } else if (field.name === "overview" || field.name === "raw") {
            if (
              !(
                data?.[field.name]
                  ?.replace(/<\/?[^>]+(>|$)/g, "")
                  .replace(/&nbsp;/g, " ").length -
                1 >=
                1
              )
            ) {
              if (errors[type]) {
                errors[type][index] = {
                  ...errors[type][index],
                  id: index,
                  [field.name]: `${field.fieldName} is required`,
                };
              }
            }
          } else if(field.name==="event_end_time"){
            if(data.event_start_time && data.event_end_time) {
              const startTime = moment(data.event_start_time, 'h:mm a');
              const endTime = moment(data.event_end_time, 'h:mm a');
              const isEndTimeBeforeStartTime = endTime.isBefore(startTime);
              if(isEndTimeBeforeStartTime){
                if (errors[type]) {
                  errors[type][index] = {
                    ...errors[type][index],
                    id: index,
                    [field.name]: `${field.fieldName} should be greater than start time`,
                  };
                }
              }
            }
          } else if (field.name === "bio_raw" && data[field.name]) {
            if (
              !(
                data?.[field.name]
                  ?.replace(/<\/?[^>]+(>|$)/g, "")
                  .replace(/&nbsp;/g, " ").length -
                1 >=
                100 &&
                data?.[field.name]
                  ?.replace(/<\/?[^>]+(>|$)/g, "")
                  .replace(/&nbsp;/g, " ").length -
                1 <=
                1500
              )
            ) {
              if (errors[type]) {
                errors[type][index] = {
                  ...errors[type][index],
                  id: index,
                  [field.name]: `Please enter minimum 100 and max 200 characters`,
                };
              } else {
                errors[type] = [
                  {
                    id: index,
                    [field.name]: `Please enter minimum 100 and max 1500 characters2`,
                  },
                ];
              }
            }
          } else if (
            field.name !== "bio_raw" &&
            field.name !== "raw" &&
            field.name !== "RISE_topic_path" &&
            field.name !== "name" &&
            field.name !== "RISE_topic_name" &&
            regex.test(data[field.name])
          ) {
          }
        }
      });
    });
  } else {
    fields.map((field) => {
      if (!formData[field.name] || !formData[field.name]?.length) {
        errors[field.name] = `${field.fieldName} is required`;
      } else {
        // if (field.name === "overview") {
        //   if (
        //     !(
        //       formData[field.name]
        //         ?.replace(/<\/?[^>]+(>|$)/g, "")
        //         .replace(/&nbsp;/g, " ").length -
        //       1 >=
        //       100 &&
        //       formData?.[field.name]
        //         ?.replace(/<\/?[^>]+(>|$)/g, "")
        //         .replace(/&nbsp;/g, " ").length -
        //       1 <=
        //       1500
        //     )
        //   ) {
        //     errors[
        //       field.name
        //     ] = `Please enter min 100 and max 1500 characters`;
        //   }
        // } else 
        // if (field.name === "overview") {
        //   if (
        //     !(
        //       formData[field.name]
        //         ?.replace(/<\/?[^>]+(>|$)/g, "")
        //         .replace(/&nbsp;/g, " ").length -
        //       1 >=
        //       1
        //     )
        //   ) {
        //     errors[
        //       field.name
        //     ] = `Overview is required`;
        //   }
        // } else 
        if (
          field.name === "bio_raw" &&
          field.name !== "RISE_topic_path"
        ) {
          if (
            formData[field.name]
              ?.replace(/<\/?[^>]+(>|$)/g, "")
              .replace(/(\r\n|\n|\r)/gm, "")
              .replace(/&nbsp;/g, " ").length === 0
          ) {
            errors[field.name] = `${field.fieldName} is required`;
          } else if (
            !(
              formData[field.name]
                ?.replace(/<\/?[^>]+(>|$)/g, "")
                .replace(/&nbsp;/g, " ").length -
              1 >=
              100 &&
              formData?.[field.name]
                ?.replace(/<\/?[^>]+(>|$)/g, "")
                .replace(/&nbsp;/g, " ").length -
              1 <=
              1500
            )
          ) {
            errors[
              field.name
            ] = `Please enter minimum 100 and max 1500 characters4`;
          }
        } else if (
          field.name === "email" &&
          !emailRegex.test(formData[field.name])
        ) {
          errors[field.name] = `Please enter a valid email`;
        } else if (
          field.name !== "email" &&
          field.name !== "course_name" &&
          field.name !== "overview" &&
          field.name !== "name" &&
          field.name !== "category_id" &&
          field.name !== "course_id" &&
          field.name !== "cover_image" &&
          field.name !== "category_name" &&
          field.name !== "title" &&
          field.name !== "url" &&
		  field.name !== "program_start_date" &&
          regex.test(formData[field.name])
        ) {
			console.log("field.name",field.name)
          errors[
            field.name
          ] = `Please not enter special characters and numbers`;
        }
      }
    });
  }
  return errors;
};

export const handleFileRead = async (event) => {
  const file = event.file;
  return await convertBase64(file);
};

export function compare(a, b) {
  if (a.id > b.id) {
    return -1;
  }
  if (a.id < b.id) {
    return 1;
  }
  return 0;
}

const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export function capitalizeFirstLetter(string) {
  string = string.toLowerCase();
  string = string.split(". ");
  if (string.length === 1) {
    string = string[0];
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    let str = [];
    string.map((_, i) => (str[i] = _.charAt(0).toUpperCase() + _.slice(1)));
    return str.join(". ");
  }
}

export const removeInlineStyle = (msg) => {
  if (msg) {
    const div = document.createElement("div");
    div.innerHTML = msg;
    let tags = [...div.getElementsByTagName("*")];
    tags?.map((tag) => tag.removeAttribute("style"));
    return div.innerHTML;
  }
  return "";
};

export const generateAvatar = (text) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  // Draw background
  context.fillStyle = stringToHslColor(text);
  context.fillRect(0, 0, canvas.width, canvas.height);

  // Draw text
  context.font = "bold 75px Assistant";
  context.fillStyle = "#fff";
  context.textAlign = "center";
  context.textBaseline = "middle";

  let first = text?.split(" ")[0]?.charAt(0)?.toUpperCase();
  let last = text?.split(" ")[1]?.charAt(0)?.toUpperCase();

  if (!last) {
    last =
      text?.split(" ")[0]?.charAt(1)?.toUpperCase() ||
      text?.split(" ")[0]?.charAt(0)?.toUpperCase();
  }
  if (!first) {
    first = "S";
    last = "U";
  }

  context.fillText(first + last, canvas.width / 2, canvas.height / 2);

  return canvas.toDataURL("image/png");
};

export const stringToHslColor = (str, s = 30, l = 80) => {
  let hash = 0;
  for (let i = 0; i < str?.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let h = hash % 360;
  return "hsl(" + h + ", " + s + "%, " + l + "%)";
};

export function downloadHandler(url, name, s3, page = 1) {
  if (!s3) {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = url.split('/').pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    axiosClient
      .post(url, { page }, { mode: 'no-cors' })
      .then((response) => {
        // create file link in browser's memory
        const blob = new Blob([response.data.join("/n")], { type: "text/csv" });
        const href = URL.createObjectURL(blob);



        // create "a" HTLM element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', name); //or any other extension
        document.body.appendChild(link);
        link.click();



        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
  }
}


export function toTitleCase(str) {
  if (typeof str === 'string') {
    let splitStr = str?.toLowerCase()?.split('.');
    for (let i = 0; i < splitStr?.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] =
        splitStr[i]?.replaceAll('\r', '').trim().charAt(0)?.toUpperCase() +
        splitStr[i]?.replaceAll('\r', '').trim().substring(1);
    }
    // Directly return the joined string
    return splitStr?.join('. ');
  }
  return str;
}